import { useMemo } from 'react';
import { checkPermissions } from 'react/utils/utils';

/**
 * Custom hook that provides permission checks for stop actions menu
 *
 * @returns {Object} - Permission flags for stop actions
 */
export const useStopActionsMenuPermissions = () => {
  const canViewStopDetails = true;

  const canArriveAtStop = useMemo(
    () => checkPermissions('ROUTE_MONITOR_ARRIVE_AT_STOP'),
    []
  );

  const canCancelStop = useMemo(
    () => checkPermissions('ROUTE_MONITOR_CANCEL_STOP'),
    []
  );

  const canDepartFromStop = useMemo(
    () => checkPermissions('ROUTE_MONITOR_DEPART_FROM_STOP'),
    []
  );

  const canMarkUndeliverable = useMemo(
    () => checkPermissions('ROUTE_MONITOR_UNDELIVERABLE_STOP'),
    []
  );

  const canMarkForRedelivery = useMemo(
    () => checkPermissions('ROUTE_MONITOR_REDELIVERY_STOP'),
    []
  );

  return {
    canViewStopDetails,
    canArriveAtStop,
    canCancelStop,
    canDepartFromStop,
    canMarkUndeliverable,
    canMarkForRedelivery
  };
};
